'use client'
import { Container, Typography } from '@mui/material'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/navigation'
import { useTranslation } from 'react-i18next'

import { usePredownloadVideos } from '@/utils/predownloadVideos'

import RoundButton from '../kokokara/ui/button/RoundButton'

const LocaleSwitcher = dynamic(() => import('@/lib/i18n/LocaleSwitcher'), {
  ssr: false,
})

interface Props {
  setPageNumber: (page: number) => void
}

export default function SelectLanguage({ setPageNumber }: Props) {
  const { t } = useTranslation()
  const { predownloadVideos, deleteVideos, loading, messages } =
    usePredownloadVideos()
  const router = useRouter()

  const isMetaQuestBrowser = () => {
    if (typeof window !== 'undefined' && window.navigator) {
      return navigator.userAgent.includes('OculusBrowser')
    }
    return false
  }

  const showPreDownloadButton = isMetaQuestBrowser()

  return (
    <Container
      sx={{
        alignItems: 'center',
        backgroundColor: '#EFF7EA',
        backgroundImage: 'url("/yomogi_bg.svg")',
        backgroundPosition: 'calc(50% + 28px) -248px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '175%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100svh',
        p: '20px',
        position: 'relative',
      }}
    >
      <Typography variant="h5" sx={{ mb: 3 }}>
        {t('home.selectLanguage')}
      </Typography>
      <LocaleSwitcher />
      <RoundButton
        sx={{ mt: 5, width: 200 }}
        fullWidth
        onClick={() => {
          setPageNumber(1)
        }}
        variant="contained"
      >
        {t('toNext')}
      </RoundButton>
      {showPreDownloadButton && (
        <>
          <RoundButton
            sx={{ mt: 5, width: 200 }}
            fullWidth
            onClick={predownloadVideos}
            variant="outlined"
            loading={loading}
          >
            事前ダウンロード
          </RoundButton>
          <RoundButton
            sx={{ mt: 5, width: 200 }}
            fullWidth
            onClick={deleteVideos}
            variant="outlined"
          >
            Video削除
          </RoundButton>
          <RoundButton
            sx={{ mt: 2, width: 320 }}
            fullWidth
            onClick={() => router.push('/vr?qr=on')}
            variant="outlined"
            // disabled={!cached || !!error} // DL直後以外cachedがtrueになることがなく、ほぼ使えないボタンとなってしまうのでdisableしない
          >
            【HMD only】QR読込ページへ
          </RoundButton>
          {messages.length > 0 && <pre>{messages.join('\n')}</pre>}
        </>
      )}
    </Container>
  )
}
